import { useContext } from "react";
import { CqrsContext } from "./CqrsProvider";

export const useCqrs = () => useContext(CqrsContext);
